import { render } from "./InputProducts.vue?vue&type=template&id=639a2818"
import script from "./InputProducts.vue?vue&type=script&lang=js"
export * from "./InputProducts.vue?vue&type=script&lang=js"

import "./InputProducts.vue?vue&type=style&index=0&id=639a2818&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__